<template>
  <div class="new-route">

    <RouteHeader title="Ruta Nueva" />

    <hr>

    <h3>1 - Datos de la Ruta:</h3>

    <label for="dateSelector">FECHA RUTA:</label>
    <datepicker
      id="dateSelector"
      v-model="routeDate"
      :language="es"
      :highlighted="highlighted"
      format="D, dd/MM/yyyy"
      input-class="form-control mw-275"
      monday-first/>
    <br>

    <b-form data-vv-scope="routeDataForm">
      <div class="row">

        <!--Nombre ruta-->
        <div class="col-md-6">
          <b-form-group id="routeNameGroup" label="NOMBRE RUTA:" label-for="name">
            <b-form-input
              id="name"
              name="name"
              type="text"
              v-model.trim="route.name"
              v-validate="'required|min:3'"
              :state="errors.first('routeDataForm.name') ? 'invalid' : ''"
              placeholder="Nombre de ruta"/>
            <span class="text-danger">{{ errors.first('routeDataForm.name') }}</span>
          </b-form-group>
        </div>

        <!--Empleados-->
        <div class="col-md-6">
          <b-form-group id="routeEmployeesGroup" label="EMPLEADOS RUTA:" label-for="km">
            <b-form-select
              id="selectedEmployees"
              name="selectedEmployees"
              v-model="selectedEmployees"
              v-validate="'required'"
              :state="errors.first('routeDataForm.selectedEmployees') ? 'invalid' : ''"
              :options="optionsEmployees"
              multiple :select-size="3">
            </b-form-select>
            <span class="text-danger">{{ errors.first('routeDataForm.selectedEmployees') }}</span>
          </b-form-group>
          <div class="mt-0 mb-4 text-muted">
            <small>Selección múltiple. Seleccionados {{selectedEmployees.length }} empleados</small>
          </div>
        </div>

        <!--Vehiculo-->
        <div class="col-md-6">
          <b-form-group id="vehiclesGroup" label="VEHÍCULO:" label-for="selectedVehicle">
            <b-form-select
              id="selectedVehicle"
              name="selectedVehicle"
              v-model="selectedVehicle"
              v-validate="'required'"
              :state="errors.first('routeDataForm.selectedVehicle') ? 'invalid' : ''"
              :options="optionsVehicles">
            </b-form-select>
            <span class="text-danger">{{ errors.first('routeDataForm.selectedVehicle') }}</span>
          </b-form-group>
        </div>

        <!--KM-->
        <div class="col-md-6">
          <b-form-group id="routeKmGroup" label="KILÓMETROS:" label-for="km">
            <b-form-input
              id="km"
              name="km"
              type="number"
              v-model.trim="route.km"
              v-validate="'required|decimal:2'"
              :state="errors.first('routeDataForm.km') ? 'invalid' : ''"
              placeholder="KM vehículo"/>
            <span class="text-danger">{{ errors.first('routeDataForm.km') }}</span>
          </b-form-group>
        </div>

      </div>
    </b-form>

    <hr class="my-5">

    <h3 class="mb-3">2 - Selecciona los clientes de la ruta</h3>

    <b-form inline novalidate>
      <b-form-group id="searchGroup" description="Filtrar clientes por nombre">
        <b-input-group>
          <b-input-group-prepend is-text>
            <font-awesome-icon icon="search" />
          </b-input-group-prepend>
          <b-form-input
            id="search"
            type="text"
            autocomplete="off"
            v-model="search"
            placeholder="Buscar" />
          <b-input-group-append>
            <b-button variant="secondary" @click="clearSearch">
              <font-awesome-icon icon="times-circle" />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-form>
    <br>

    <b-table
      class="h-400"
      striped
      borderless
      hover
      :items="clients"
      :fields="tableFields"
      sort-by="createdAt"
      :sort-desc="true"
      responsive="sm"
      :filter="search"
      @filtered="onFiltered"
      @row-clicked="rowClicked">
      <!-- Custom column -->
      <template slot="show_details" slot-scope="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          <font-awesome-icon icon="chevron-circle-down" />
        </b-button>
      </template>
      <!-- Table Hidden area -->
      <template slot="row-details" slot-scope="row">
        <b-card>
          <b-row>
            <b-col sm="6" class="mb-2">
              <p class="mb-0"><b>Forma Pago:</b></p>
              <span>{{ row.item.paymentMethod }}</span>
            </b-col>
            <b-col sm="6" class="mb-2">
              <p class="mb-0"><b>Frec. Entrega:</b></p>
              <template v-for="frec in row.item.deliveryFrequency">
                {{ frec }}
              </template>
            </b-col>
            <b-col sm="6" class="mb-2">
              <p class="mb-0"><b>Precios:</b></p>
              <template v-for="(p, idx) in row.item.productPrices">
                <p class="m-0" :key="idx"> {{ products[p.id].name }} - <b class="text-muted">{{ p.price }}€</b></p>
              </template>
            </b-col>
            <b-col sm="6" class="mb-2">
              <p class="mb-0"><b>Horario Entrega:</b></p>
              <template v-for="(d, idx) in row.item.deliverySchedule">
                <p :key="idx" class="m-0">
                  <b-badge>Inicio</b-badge>: {{ d.startTime }} - <b-badge>Fin</b-badge> {{ d.endTime }}
                </p>
              </template>
            </b-col>
            <b-col sm="6" class="mb-2">
              <p class="mb-0"><b>Notas</b></p>
              <span>{{ row.item.notes }}</span>
            </b-col>
          </b-row>

          <b-button size="sm" variant="outline-primary" @click="row.toggleDetails">Cerrar</b-button>
        </b-card>
      </template>
    </b-table>

    <template v-if="selectedClients.length > 0">
      <hr class="mt-5 mb-5">
      <h3 class="mb-0">3 - Ordena los clientes de la ruta</h3>
      <p>
        <small class="text-muted">(Arrastrar y soltar)</small>
      </p>
      <draggable v-model="selectedClients">
        <div v-for="client in selectedClients" :key="client.id">
          <SortableClientCard :client="client" :products="products" class="pointer-cursor"/>
        </div>
      </draggable>
    </template>

    <template v-if="selectedClients.length > 0">
      <hr class="mt-5 mb-5">
      <h3>4 - Previsión de productos por cliente</h3>
      <section>
        <div v-for="(client, i) in selectedClients" :key="i">
          <PrevisionClientCardfrom
            :client="client"
            :products="products"
            @onPrevisionUpdate="onPrevisionUpdate"/>
        </div>
      </section>
    </template>

    <hr>
    <div v-if="previsionErrMsg !== ''">
      <b-alert show variant="danger"> {{ previsionErrMsg }} </b-alert>
    </div>
    <b-button v-if="selectedClients.length > 0" variant="primary" @click="onSubmit">
      Crear Ruta
      <b-spinner v-if="isRouteBtnLoading" small type="grow" label="Spinning" />
    </b-button>

    <br>
    <br>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import { dateMixin } from '@/mixins/dateMixin'
import RouteHeader from '../RouteHeader'
import SortableClientCard from './SortableClientCard'
import PrevisionClientCardfrom from './PrevisionClientCard'

export default {
  name: 'RouteNew',
  mixins: [dateMixin],
  components: {
    RouteHeader,
    SortableClientCard,
    PrevisionClientCardfrom,
    draggable,
    Datepicker
  },
  data () {
    return {
      route: {},
      clients: [],
      clientsDrag: [],
      selectedClients: [],
      tableFields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'phone',
          label: 'Telf.'
        },
        {
          key: 'address',
          label: 'Dirección',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'Fec. alta'
        },
        {
          key: 'show_details',
          label: ''
        }
      ],
      search: '',
      products: {},
      prevision: [],
      previsionErrMsg: '',
      routeDate: new Date(),
      es: es,
      highlighted: {
        dates: [ new Date() ]
      },
      employees: [],
      vehicles: [],
      selectedEmployees: [],
      selectedVehicle: null
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'isRouteBtnLoading',
      'isRouteDataLoading'
    ]),
    optionsEmployees () {
      return this.employees.map(e => {
        return { value: e.id, text: `${e.name} ${e.surname}` }
      })
    },
    optionsVehicles () {
      const v = this.vehicles
        .map(v => {
          return { value: v.id, text: `${v.brand} · ${v.model}` }
        })
      return [{ value: null, text: '-- Selecciona vehículo' }, ...v]
    }
  },
  created () {
    this.loadClients()
    this.loadProducts()
    this.loadVehicles()
    this.loadEmployees()
  },
  methods: {
    ...mapActions([
      'getClients',
      'getProducts',
      'createRoute',
      'setAlertData',
      'getVehicles',
      'getActiveEmployees'
    ]),
    ...mapMutations([
      'toggleRouteBtnLoading'
    ]),
    onSubmit () {
      this.validateForm()
    },
    /**
     * Coge la prevision y la mete en los clientes
     * Genera el dato para enviar con la prevision (cantidad y articulo), los clientes seleccionados..
     */
    validateForm () {
      this.$validator.validateAll('routeDataForm')
        .then((valid) => {
          if (!valid) {
            this.previsionErrMsg = 'Faltan datos de la ruta. 👆'
            return false
          }
        })

      this.previsionErrMsg = ''
      // Validar:
      // - Tener 1 cliente o más seleccionado
      // - Que tengan cantidad a repartir y coincida las entregas con los clientes seleccionados

      if (this.selectedClients.length === 0) {
        this.previsionErrMsg = 'No has seleccionado clientes'
        return false
      }

      // Longitud prevision con longitud clientes
      if (this.selectedClients.length !== this.prevision.length) {
        this.previsionErrMsg = 'Faltan previsiones de productos'
        return false
      }

      // responses debe tener todos a true para que sean buenas
      let responses = []
      this.prevision.map(prev => {
        const products = prev.products
        if (products.length === 1 && this.isFalsy(products[0].quantity)) {
          this.previsionErrMsg = 'Faltan previsiones de productos (Vacio)'
          return false
        } else {
          const noseq = prev.products.map(prod => {
            // comprobar que al menos uno tiene valor
            // en isFalsy, si hay valores vacios, devuelve TRUE, comprobar que hay algun FALSE
            return !this.isFalsy(prod.quantity)
          })
          const hayValores = noseq.includes(true)
          responses.push(hayValores)
        }
      })

      if (!responses.every(item => item === true)) {
        this.previsionErrMsg = 'Faltan previsiones de productos'
        return false
      }

      // Si hay algun error, salimos
      if (this.previsionErrMsg !== '') {
        return false
      }

      const clientsObj = {}

      this.selectedClients.map((c, idx) => {
        const prevision = this.prevision.find(pre => pre.clientId === c.id)
        clientsObj[c.id] = {
          position: idx, // Orden de entrega
          prevision, // Prevision de productos entregados
          deliveredProducts: {}, // Entregados.productoId: valor
          deliveryNote: null, // Albarán
          deliveryStatus: 'pending', // Pending · Delivered · Cancelled
          deliveryComment: null, // Comentarios o notas
          isDeliverySigned: null, // Ha firmado?
          isDeliveryPaid: false, // Ha pagado?
          paidQuantity: null // Total pagado
        }
      })

      const data = {
        name: this.route.name,
        km: this.route.km,
        date: this.dateToMilliseconds(this.routeDate),
        createdAt: this.currentDateMilliseconds(),
        createdBy: this.userId,
        status: 'inactive', // inactive, active, delivered, cancelled
        clients: clientsObj,
        expenses: [] // Gastos => concepto + cantidad
      }

      this.toggleRouteBtnLoading(true)
      this.createRoute(data)
        .then((res) => {
          this.toggleRouteBtnLoading(false)
          this.$router.push({ name: 'Routes' })
          this.setAlertData({
            visible: true,
            msg: 'Ruta Creada 🥳',
            type: 'success'
          })
        })
        .catch((err) => {
          this.toggleRouteBtnLoading(false)
          console.log('[CreateRoute]')
          console.log(err)
        })
    },
    loadClients () {
      this.getClients()
        .then((res) => {
          res.forEach(doc => {
            this.clients.push(
              {
                id: doc.id,
                ...doc.data(),
                createdAt: this.dateDDMMYYYY(doc.data().createdAt),
                _rowVariant: ''
              }
            )
          })
        })
        .catch((err) => {
          console.log('[getClients]')
          console.log(err)
        })
    },
    loadProducts () {
      this.getProducts()
        .then((res) => {
          res.forEach(doc => {
            this.products[doc.id] = { id: doc.id, ...doc.data(), createdAt: this.dateDDMMYYYY(doc.data().createdAt) }
          })
        })
        .catch((err) => {
          console.log('[getProducts]')
          console.log(err)
        })
    },
    rowClicked (item, index, event) {
      const client = this.clients.find(c => c.id === item.id)
      // Toogle Row Variant Info when clicked
      client._rowVariant === '' ? client._rowVariant = 'info' : client._rowVariant = ''

      if (client._rowVariant === '') {
        // Remove from selected items
        const idx = this.selectedClients.findIndex(c => c.id === item.id)
        this.selectedClients.splice(idx, 1)
      } else {
        // Push to selected items
        this.selectedClients.push(client)
      }
    },
    clearSearch () {
      this.search = ''
    },
    onFiltered (filteredItems) {
      // console.log('filteredItems')
      // console.log(filteredItems)
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length
      // this.currentPage = 1
    },
    onPrevisionUpdate (val) {
      this.previsionErrMsg = ''
      const client = this.prevision.find(c => c.clientId === val.clientId)
      if (client) {
        const product = client.products.find(p => p.productId === val.productId)
        if (product) {
          product.quantity = val.quantity
        } else {
          client.products.push({ productId: val.productId, quantity: val.quantity })
        }
      } else {
        const data = {
          clientId: val.clientId,
          products: [
            {
              productId: val.productId,
              quantity: val.quantity
            }
          ]
        }
        this.prevision.push(data)
      }
    },
    isFalsy (value) {
      return value === '' || value === '0' || value === 0
    },
    loadVehicles () {
      this.getVehicles()
        .then((res) => {
          if (res.empty) {
            console.log('No hay Vehicles...')
            return false
          }
          res.forEach(doc => {
            this.vehicles.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug('getVehicles')
          console.log(err)
        })
    },
    loadEmployees () {
      this.getActiveEmployees()
        .then((res) => {
          console.log('res')
          console.log(res)
          if (res.empty) {
            console.log('No hay Employees...')
            return false
          }
          res.forEach(doc => {
            this.employees.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.debug('getActiveEmployees')
          console.log(err)
        })
    }
  }
}
</script>

<style lang="stylus">
.new-route
  .mw-275
    width 275px
    max-width 275px
    background-color white !important

  .pointer-cursor
    cursor move

  .h-400
    max-height 400px
    overflow scroll

</style>
